
























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchComposeWeijuejing extends Vue {
  @Prop()
  private message: any;
}
